import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ProviderDetail';
import ProviderDetail from './ProviderDetail';
import { StoreState } from 'src/store/reducers';
import { getProvider, getSupervisorProviders } from 'src/store/actions/provider-actions';
import { QueryParams } from '../../../../../../types/grid';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        provider: state.providers.current,
        userData: state.auth.data,
        providersuper: state.providers.supervisorProviders,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getProvider(id)),
        getProvidersSupervisor: (params: QueryParams) => dispatch(getSupervisorProviders(params)),
    };
}

const ProviderDetailScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProviderDetail);

export default ProviderDetailScreen;
